import { Box, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useSearchParams } from "react-router"

import { useAuth0 } from "@auth0/auth0-react"
import { Navigate } from "react-router"
import logo from "../../assets/mobilus-logo.png"
import LoadingPage from "./LoadingPage"
import LoginButton from "./LoginButton"

export const PublicHomePage: FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get("returnTo") || "/"

  if (isLoading) {
    return <LoadingPage />
  }
  if (isAuthenticated) {
    return <Navigate to={returnTo} replace />
  }

  return (
    <Box
      data-testid="public-home-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: 2,
      }}
    >
      <img src={logo} alt="Mobilus Logo" data-testid="public-home-logo" />
      <Typography variant="h3" component="div" gutterBottom mt={10}>
        Mobilus Delivery
      </Typography>
      <Typography variant="body1" gutterBottom>
        Powered by Mobilus Technologies inc.
      </Typography>
      <Stack direction="column" spacing={2} mt={2} alignItems={"center"}>
        <LoginButton returnTo={returnTo} />
      </Stack>
    </Box>
  )
}
